var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#555;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.921,5.236a.806.806,0,0,0,0,1.141L9.379,9.836,5.918,13.3a.806.806,0,1,0,1.14,1.141l3.461-3.461,3.459,3.461a.806.806,0,1,0,1.14-1.141L11.659,9.836l3.459-3.459a.806.806,0,1,0-1.14-1.141L10.52,8.7,7.059,5.236a.806.806,0,0,0-1.14,0Z",
    transform: "translate(5.726 3.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.429,1A3.5,3.5,0,0,1,28,4.429V21.571A3.5,3.5,0,0,1,24.429,25H11.789a3.634,3.634,0,0,1-2.712-1.2L.43,14.114a1.663,1.663,0,0,1,0-2.232L9.077,2.2A3.634,3.634,0,0,1,11.789,1H24.429ZM11.789,2.714a1.817,1.817,0,0,0-1.357.6L1.785,13l8.648,9.686a1.817,1.817,0,0,0,1.355.6H24.429a1.751,1.751,0,0,0,1.785-1.714V4.429a1.751,1.751,0,0,0-1.785-1.714Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.f2f56e03fc03b204786bb1e57dbbef3f.svg";
export { ForwardRef as ReactComponent };